/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Contact_Code_Trees_Contact_Code_CountInputs */

const en_tables_contact_code_trees_contact_code_count = /** @type {(inputs: Tables_Contact_Code_Trees_Contact_Code_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

const de_tables_contact_code_trees_contact_code_count = /** @type {(inputs: Tables_Contact_Code_Trees_Contact_Code_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

/**
* | output |
* | --- |
* | "Count" |
*
* @param {Tables_Contact_Code_Trees_Contact_Code_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_contact_code_trees_contact_code_count = /** @type {((inputs?: Tables_Contact_Code_Trees_Contact_Code_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Contact_Code_Trees_Contact_Code_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_contact_code_trees_contact_code_count(inputs)
	return de_tables_contact_code_trees_contact_code_count(inputs)
});